import Crk from '@/mixins/crk/crk';
import deviceInfo from '@/modules/Device/Device';
import { Component, Mixins } from 'vue-property-decorator';
import { $authViaDigitalSign } from '../api';
import { AuthViaDigitalSignData, AuthViaDigitalSignResultData, DigitalSignForAuth } from '../types/auth-via-digital-sign';
import { DigitalSign } from '../types/digital-sign';
import { DigitalSignResult } from '@/mixins/crk/interface';
import { IAuthData } from '@/api/auth/interface';
import AuthConfirmViaOtp from './AuthConfirmViaOtp';
import { GenerateSmsResultData } from '@/api/sms/types';
import { Mutation } from 'vuex-class';
import { PROFILE_MODULE_NAME } from '@/store/modules/profile';

@Component
export default class AuthDigitalSign extends Mixins(
	Crk,
	AuthConfirmViaOtp
) {

	@Mutation('setDigitalSign', { namespace: PROFILE_MODULE_NAME })
	setProfileDigitalSign!: (digitalSign: DigitalSign | null) => void

	isDigitalSignSelectionView: boolean = true

	selectedDigitalSign: DigitalSign | null = null

	signResult: DigitalSignResult | null = null

	passwordDialog: boolean = false

	digitalSignMfoUl: string = ''

	generateSmsRequest = (): Promise<GenerateSmsResultData | null> =>
		this.authViaDigitalSign()

	async authViaDigitalSignRequest(): Promise<AuthViaDigitalSignResultData | null> {
		return $authViaDigitalSign(this.getAuthViaDigitalSignData());
	}

	onSelectDigitalSign(digitalSign: DigitalSign) {
		this.setProfileDigitalSign(digitalSign);

		this.digitalSignCrmId.flCrmId = digitalSign.flCrmId;
		this.digitalSignCrmId.ulCrmId = digitalSign.ulCrmId;
		this.digitalSignMfoUl = digitalSign.mfoUl || '';
		this.isDigitalSignSelectionView = false;
		this.selectedDigitalSign = digitalSign;
	}

	async onSubmitDigitalSignPassword() {
		this.signResult = await this.signAuthData();

		if (!this.signResult.error) await this.authViaDigitalSign();
	}

	async authViaDigitalSign(): Promise<GenerateSmsResultData | null> {
		const authResult = await this.authViaDigitalSignRequest();

		authResult && this.handleAuthViaDigitalSign(authResult);

		return {
			id: authResult?.verifyId || 0
		};
	}

	async signAuthData(): Promise<DigitalSignResult> {
		return this.signObject(
			this.getDigitalSignForAuth(),
			this.selectedDigitalSign,
			this.password
		);
	}

	handleAuthViaDigitalSign(authResult: AuthViaDigitalSignResultData) {
		this.passwordDialog = false;

		if (authResult.needOtp) {
			this.otpVerifyId = authResult.verifyId || 0;
			this.otpRemainingTime = authResult.remainingTime || 0;
			this.smsDialogIsActive = true;
		} else {
			this.signInAndLoadCompany(authResult as IAuthData);

			this.otpVerifyId = 0;
			this.smsDialogIsActive = false;
		}
	}

	getDigitalSignForAuth(): DigitalSignForAuth {
		return {
			...deviceInfo,
			...this.digitalSignCrmId
		};
	}

	getAuthViaDigitalSignData(): AuthViaDigitalSignData {
		return {
			object: this.signResult?.result?.base64ToString || '',
			sign: this.signResult?.result?.sign || '',
			mfoUl: this.digitalSignMfoUl || undefined,
			...this.digitalSignCrmId
		};
	}

	onBackFromConfirmationDigitalSign() {
		this.isDigitalSignSelectionView = true;
		this.errorMessagePassword = '';
		this.password = '';
	}

}
